import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const purchases = [{
  name: 'Laura M.',
  city: 'Buenos Aires',
  product: 'MegaPack + Gabinete Digital 360',
  time: 'hace 2 min'
}, {
  name: 'Mariela C.',
  city: 'Rosario',
  product: 'MegaPack Método 360',
  time: 'hace 5 min'
}, {
  name: 'Sofía V.',
  city: 'Córdoba',
  product: 'MegaPack + Gabinete Digital 360',
  time: 'hace 8 min'
}, {
  name: 'Florencia L.',
  city: 'Tucumán',
  product: 'MegaPack Método 360',
  time: 'hace 12 min'
}, {
  name: 'Ana R.',
  city: 'Mendoza',
  product: 'MegaPack + Gabinete Digital 360',
  time: 'hace 15 min'
}, {
  name: 'Valeria T.',
  city: 'Santa Fe',
  product: 'MegaPack + Gabinete Digital 360',
  time: 'hace 18 min'
}, {
  name: 'Gabriela R.',
  city: 'Salta',
  product: 'MegaPack Método 360',
  time: 'hace 22 min'
}, {
  name: 'Carolina P.',
  city: 'La Plata',
  product: 'MegaPack + Gabinete Digital 360',
  time: 'hace 25 min'
}, {
  name: 'Daniela S.',
  city: 'Mar del Plata',
  product: 'MegaPack Método 360',
  time: 'hace 30 min'
}, {
  name: 'Julieta F.',
  city: 'Neuquén',
  product: 'MegaPack + Gabinete Digital 360',
  time: 'hace 35 min'
}, {
  name: 'Romina G.',
  city: 'San Juan',
  product: 'MegaPack Método 360',
  time: 'hace 40 min'
}, {
  name: 'Luciana B.',
  city: 'Paraná',
  product: 'MegaPack + Gabinete Digital 360',
  time: 'hace 45 min'
}];
export function PurchaseNotifications() {
  const [current, setCurrent] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let index = 0;
    // Show first notification after 6 seconds
    const initialTimeout = setTimeout(() => {
      setCurrent(index);
      setVisible(true);
      // Hide after 4 seconds
      setTimeout(() => setVisible(false), 4000);
      index = (index + 1) % purchases.length;
    }, 6000);
    // Then show every 12-18 seconds (randomized)
    const interval = setInterval(() => {
      setCurrent(index);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
      index = (index + 1) % purchases.length;
    }, 12000 + Math.random() * 6000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const purchase = current !== null ? purchases[current] : null;
  return <div className="fixed bottom-4 left-4 z-50" style={{
    maxWidth: 'calc(100vw - 32px)'
  }} data-id="element-269">
      <AnimatePresence data-id="element-270">
        {visible && purchase && <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="flex items-center gap-3 bg-white border border-cyan-brand/30 rounded-xl px-4 py-3 shadow-lg max-w-sm" style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
      }} data-id="element-271">
            {/* Avatar */}
            <div className="flex h-9 w-9 shrink-0 items-center justify-center bg-cyan-brand/10 text-cyan-brand rounded-full text-sm font-black" data-id="element-272">
              👶
            </div>

            {/* Info */}
            <div className="min-w-0 flex-1" data-id="element-273">
              <p className="text-xs font-bold text-gray-900 m-0 truncate" data-id="element-274">
                {purchase.name} de {purchase.city}
              </p>
              <p className="text-[10px] text-gray-600 m-0 truncate" data-id="element-275">
                compró el{' '}
                <span className="font-semibold text-cyan-brand" data-id="element-276">
                  {purchase.product}
                </span>
              </p>
              <p className="text-[9px] text-gray-400 m-0 mt-0.5" data-id="element-277">
                🕐 {purchase.time}
              </p>
            </div>

            {/* Verified badge */}
            <div className="shrink-0" data-id="element-278">
              <span className="text-[9px] font-bold text-green-600 bg-green-50 border border-green-200 rounded-full px-1.5 py-0.5" data-id="element-279">
                ✓ Verificado
              </span>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}